import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.NumberGrid.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.NumberGrid.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.numbersOnLine = [];
  this.gridNumbers = [];
  this.highlightedItem = null;
  this.remainingMissingNumbers = 0;
};

EDC.Games.NumberGrid.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.NumberGrid.Scenes.Main.prototype.constructor = EDC.Games.NumberGrid.Scenes.Main;

const NG = EDC.Games.NumberGrid.Scenes.Main.prototype;

NG.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

NG.createTemplateUI = function () {
  // const title = this.add.sprite(215, 400, 'title');
  // const instructions = this.add.sprite(215, 720, 'instructions').setScale(0.9);
  // const gridFrame = this.add.sprite(920, 535, 'grid-frame');

  // hit area for cursor
  const rect = new Phaser.Geom.Rectangle(1400, 25, 550, 1000);
  const hitArea = this.add.graphics({ fillStyle: { alpha: 0 } });
  hitArea.fillRectShape(rect);
  hitArea.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
  this.cursorManager.setDefaultDraggableEvents(hitArea);

  this.createPad();
};

NG.loadIteration = function () {
  this.createGrid();
};

NG.createGrid = function () {
  const { numbersMissing } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  for (let i = 1; i < 101; i++) {
    const block = this.createDigits(i);
    const { x, y } = this.getGridNumbersPosition(i);
    block.x = x;
    block.y = y;
    this.gridNumbers.push(block);
  }
  // swap numbers with missingImg
  for (let i = 0; i < this.gridNumbers.length; i++) {
    for (let j = 0; j < numbersMissing.length; j++) {
      if (this.gridNumbers[i].numberText === numbersMissing[j]) {
        const value = this.gridNumbers[i].numberText;
        this.gridNumbers[i].destroy();
        this.gridNumbers[i] = this.createMissing(value);
      }
    }
  }
};

NG.createMissing = function (value) {
  this.remainingMissingNumbers = this.remainingMissingNumbers + 1;
  const { x, y } = this.getGridNumbersPosition(value);
  const container = this.add.container(x, y);
  const block = this.add.sprite(0, 0, 'block');
  container.add(block);
  container.setSize(81, 91);
  const missingImg = this.add.sprite(0, 0, 'missingImg').setOrigin(0.5);
  container.add(missingImg);
  container.numberText = value;
  this.shakeAnimation(container.last);
  const rect = new Phaser.Geom.Rectangle(-35, 0, 81, 91);
  container.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
  this.cursorManager.setDefaultDraggableEvents(container);
  container.on('pointerup', this.highlighOn.bind(this, container), this);
  return container;
};

NG.highlighOn = function (container) {
  if (this.highlightedItem) {
    this.scaleOff(this.highlightedItem.last);
    if (this.highlightedItem.numberText !== container.numberText) {
      this.highlightedItem = container;
      this.scaleOn(this.highlightedItem.last);
    } else {
      this.highlightedItem = null;
    }
  } else {
    this.highlightedItem = container;
    this.scaleOn(this.highlightedItem.last);
  }
};

NG.scaleOff = function (item) {
  item.clearTint();
  item.questionMark.destroy();
  this.tweens.add({
    targets: item,
    scaleX: 1,
    scaleY: 1,
    duration: 90,
    ease: 'Sine.easeInOut',
  });
};

NG.scaleOn = function (item) {
  item.setTint(0x0fff00);
  const font = {
    font: '90px',
    fill: 'blue',
  };
  item.questionMark = this.add.text(this.highlightedItem.x, this.highlightedItem.y, '?', font).setOrigin(0.5);
  this.tweens.add({
    targets: item,
    scaleX: 2.5,
    scaleY: 2.5,
    duration: 90,
    ease: 'Sine.easeInOut',
  });
};

NG.getGridNumbersPosition = function (index) {
  index -= 1;
  const a = index % 10;
  const b = Math.floor(index / 10);
  const x = 540 + a * 81;
  const y = 114 + b * 91;
  return { x, y };
};

NG.createDigits = function (value) {
  const container = this.add.container(0, 0);
  const block = this.add.sprite(0, 0, 'block');
  container.add(block);
  container.setSize(81, 91);
  let digits = [];
  let val = value;
  while (Math.floor(val / 10) > 0) {
    digits.push(val % 10);
    val = Math.floor(val / 10);
  }
  digits.push(val);
  digits = digits.reverse();
  let width = 0;
  if (digits.length > 1) {
    width = -10;
    if (value > 19) {
      width = -15;
    }
  }
  if (digits.length > 2) {
    width = -25;
  }
  for (let i = 0; i < digits.length; i++) {
    const sprite = this.add.sprite(width, 5, `grid-${digits[i]}`).setOrigin(0.5);
    width += sprite.width;
    if (i > 0 && value > 19) {
      sprite.x = digits[i - 1].x + digits[i - 1].width - 5;
    }
    if (i > 1) {
      sprite.x -= 5;
    }
    container.add(sprite);
    digits[i] = sprite;
  }
  container.numberText = value;
  return container;
};

NG.createPad = function () {
  let rect;
  const container = this.add.container(1690, 550);
  const frame = this.add.sprite(0, 0, 'pad-frame');
  container.setSize(frame.displayWidth, frame.displayWidth);

  const helper = this.add.sprite(0, -260, 'helper').setVisible(true);

  const buttonErase = this.add.sprite(125, 260, 'button-erase');
  rect = new Phaser.Geom.Rectangle(-50, 0, 109, 73);
  buttonErase.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
  this.cursorManager.setDefaultDraggableEvents(buttonErase);
  buttonErase.on('pointerup', this.eraseNumber.bind(this, helper), this);
  buttonErase.on('pointerover', () => {
    buttonErase.setTint(0xff0000);
  });
  buttonErase.on('pointerout', () => {
    buttonErase.clearTint();
  });

  const buttonOk = this.add.sprite(-125, 260, 'button-ok');
  rect = new Phaser.Geom.Rectangle(-50, 0, 109, 73);
  buttonOk.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
  this.cursorManager.setDefaultDraggableEvents(buttonOk);
  buttonOk.on('pointerup', this.checkAnswer.bind(this, helper), this);
  buttonOk.on('pointerover', () => {
    buttonOk.setTint(0x0ffff0);
  });
  buttonOk.on('pointerout', () => {
    buttonOk.clearTint();
  });

  container.add(frame);
  container.add(helper);
  container.add(buttonOk);
  container.add(buttonErase);

  for (let i = 0; i < 10; i++) {
    const { x, y } = this.getPadNumbersPosition(i);
    const number = this.add.sprite(x, y, `pad-${i}`);
    number.numberText = i;
    rect = new Phaser.Geom.Rectangle(-50, 0, 61, 79);
    number.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
    this.cursorManager.setDefaultDraggableEvents(number);
    number.on('pointerup', this.addNumberToLine.bind(this, number, helper), this);
    number.on('pointerover', () => {
      number.setTint(0x0ffff0);
    });
    number.on('pointerout', () => {
      number.clearTint();
    });
    container.add(number);
  }
};

NG.eraseNumber = function (helper) {
  if (this.numbersOnLine.length > 0) {
    const lastNumber = this.numbersOnLine.pop();
    lastNumber.destroy();
    if (this.numbersOnLine.length === 0) {
      helper.setVisible(true);
    } else {
      this.numbersOnLine[0].x = 1690;
    }
  }
};

NG.addNumberToLine = function (number, helper) {
  helper.setVisible(false);
  if (this.numbersOnLine.length < 2) {
    const digit = this.add.sprite(0, 0, `pad-${number.numberText}`);
    digit.numberText = number.numberText;
    if (this.numbersOnLine.length < 1) {
      digit.x = 1690;
      digit.y = 290;
    } else {
      this.numbersOnLine[0].x = 1658;
      digit.x = 1722;
      digit.y = 290;
    }
    this.numbersOnLine.push(digit);
  }
};

NG.getPadNumbersPosition = function (index) {
  let x;
  let y;
  if (index === 0) {
    x = 0;
    y = 260;
  } else {
    index -= 1;
    const a = index % 3;
    const b = Math.floor(index / 3);
    x = -125 + a * 125;
    y = -100 + b * 120;
  }
  return { x, y };
};

NG.shakeAnimation = function (image) {
  image.shakeAnim = this.tweens.add({
    targets: image,
    angle: image.angle - 6,
    duration: 90,
    ease: 'Sine.easeInOut',
    repeat: 5,
    delay: 6000,
    yoyo: true,
    onComplete: this.shakeAnimation.bind(this, image),
  });
};

NG.getNumberAnswer = function () {
  let total;
  const digits = [];
  for (let i = 0; i < this.numbersOnLine.length; i++) {
    digits.push(this.numbersOnLine[i].numberText);
  }
  total = digits.join('');
  total = Number(total);
  return total;
};

NG.replaceMissing = function () {
  const value = this.highlightedItem.numberText;
  const block = this.createDigits(value);
  const { x, y } = this.getGridNumbersPosition(value);
  block.x = x;
  block.y = y;
  block.setAlpha(0.1);
  const sprite = block.getAt(0);
  sprite.setTint(0x00f400);
  this.tweens.add({
    targets: block,
    alpha: 1,
    duration: 300,
    ease: 'Linear',
  });
  this.gridNumbers[value - 1].destroy();
  this.gridNumbers[value - 1] = block;
};

NG.getNumberAnswer = function () {
  let total;
  const digits = [];
  for (let i = 0; i < this.numbersOnLine.length; i++) {
    digits.push(this.numbersOnLine[i].numberText);
  }
  total = digits.join('');
  total = Number(total);
  return total;
};

NG.checkAnswer = function (helper) {
  const total = this.getNumberAnswer();
  if (this.highlightedItem) {
    if (this.highlightedItem.numberText === total) {
      this.remainingMissingNumbers = this.remainingMissingNumbers - 1;
      this.playCorrect();
      this.highlightedItem.last.shakeAnim.stop();
      this.replaceMissing();
      this.highlightedItem = null;
      this.numbersOnLine.map(x => x.destroy());
      this.numbersOnLine = [];
      helper.setVisible(true);
    } else {
      this.playWrong();
      this.scaleOff(this.highlightedItem.last);
      this.shakeWrongAnswer(this.highlightedItem.last, total);
      this.highlightedItem.last.setTint(0xff0000);
      this.highlightedItem = null;
      this.numbersOnLine.map(x => x.destroy());
      this.numbersOnLine = [];
      helper.setVisible(true);
    }
  } else {
    this.pickANumberMessage();
  }
  if (this.remainingMissingNumbers === 0) {
    this.time.delayedCall(2000, this.nextIteration, [], this);
  }
};

NG.shakeWrongAnswer = function (image, total) {
  const font = {
    font: '65px Arial',
    fill: 'red',
    stroke: 'red',
    strokeThickness: 5,
  };
  const number = this.add.text(this.highlightedItem.x,
    this.highlightedItem.y + 5, total, font).setOrigin(0.5);
  this.time.delayedCall(1000, this.clearImageTint, [image, number], this);
  this.tweens.add({
    targets: image,
    x: image.x - 10,
    duration: 60,
    ease: 'Linear',
    repeat: 6,
    yoyo: true,
    onComplete: this.scaleOff.bind(this, image),
  });
};

NG.clearImageTint = function (image, number) {
  image.clearTint();
  number.destroy();
};

NG.pickANumberMessage = function () {
  const container = this.add.container(480, 400);
  const bgwrong = this.add.graphics(480, 400);
  bgwrong.fillStyle(0x000000, 0.85);
  bgwrong.fillRoundedRect(-70, -50, 1050, 150, 50);
  container.add(bgwrong);
  const text = this.add.text(-50, 0, 'PICK A MISSING NUMBER', {
    fontFamily: 'font001',
    fontStyle: 'bold',
    fontSize: '76px',
    fill: 'white',
    align: 'center',
  });
  container.add(text);
  this.tweens.add({
    targets: container,
    alpha: 1,
    duration: 2000,
    ease: 'Sine.easeInOut',
    onComplete: this.removeMessage.bind(this, container),
  });
};

NG.removeMessage = function (message) {
  message.destroy();
};

NG.nextIteration = function () {
  this.remainingMissingNumbers = 0;
  this.gridNumbers.map(x => x.destroy());
  this.gridNumbers = [];

  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

export default EDC.Games.NumberGrid.Scenes.Main;
